import './Description.css'

function Description() {

    return (
        <div className="description">
            <p>Avalie em menos de um minuto!</p>
            <p>De 0 a 10, o quanto você recomenda a Magazine Luiza para um amigo ou parente? (obrigatório)</p>
            <p>Escolha um dos números abaixo, onde 0 significa "Não Recomendo" e 10 "Recomendo Muito".</p>
        </div>
    );       
};

export default Description